import { Card, Col } from 'react-bootstrap'

export const CEOTodaySnap = ({ data }) => {
    return (
        <Col lg={2}>
            <Card className="h-100 rounded-3 p-0 position-relative" style={{ backgroundColor: "#ffffff", border: "1px solid #e3e3e3", }}>
                <Card.Body className="px-3 pt-3 pb-2 mb-0 d-flex flex-column justify-content-between h-100">
                    <div className="mb-0">
                        <span className="d-block mb-0 pb-0" style={{ fontWeight: 500, fontSize: '16px', }}>
                            Daily Snapshots
                        </span>
                        <span className="text-muted d-block" style={{ fontSize: "11px" }}>
                            Today's overview
                        </span>
                    </div>

                    <hr style={{ height: '0.1rem' }} />

                    <div className="d-flex flex-column align-items-center justify-content-evenly flex-grow-1 gap-1 text-center">
                        {[
                            { label: "Follow-ups Due", val: data?.dueFollowups, color: "#d97706", bg: "#fffbeb", icon: "fa-regular fa-clock" },
                            { label: "Deals Closed", val: data?.closedDue, color: "#16a34a", bg: "#f0fdf4", icon: "fa-solid fa-trophy" },
                            { label: "Tickets Raised", val: data?.tickets_raised, color: "#e11d48", bg: "#fff1f2", icon: "fa-regular fa-life-ring" },
                            { label: "Projects Started", val: data?.projects, color: "#7a3a5e", bg: "#faf5f8", icon: "fa-solid fa-rocket" },
                        ].map((item, idx) => (
                            <div
                                key={idx}
                                className={`py-2 ${idx !== 0 ? 'border-top' : ''} w-100 d-flex flex-column align-items-center text-center rounded-2 px-1`}
                                style={{
                                    borderColor: "#f0f4fc",
                                    alignSelf: 'center',
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                <h4 className=" mb-0" style={{ fontWeight: 400, letterSpacing: "-0.02em", fontSize: "3rem", color: "#0f172a" }}>
                                    {item.val}
                                </h4>
                                <div className="d-flex align-items-center gap-1 mb-1">
                                    <span
                                        className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                        style={{ width: 18, height: 18, backgroundColor: item.bg, color: item.color, fontSize: "12px" }}
                                    >
                                        <i className={item.icon}></i>
                                    </span>
                                    <span className="text-muted fw-medium" style={{ fontSize: "12px", letterSpacing: "-0.01em" }}>
                                        {item.label}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </Card.Body>
            </Card>
        </Col>
    )
}
